/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'activateAccountPermissions',
    message: messages.SUCCESS_ACTIVATE_ACCOUNT_PERMISSIONS,
    method: 'PATCH',
    path: '/account/:accountId/permissions/activate',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.ACTIVATE_ACCOUNT_PERMISSION,
    requestSchema: requestSchemas.accountPermissions.activateAccountPermissions,
  },
  {
    action: 'deactivateAccountPermissions',
    message: messages.SUCCESS_DEACTIVATE_ACCOUNT_PERMISSIONS,
    method: 'PATCH',
    path: '/account/:accountId/permissions/deactivate',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DEACTIVATE_ACCOUNT_PERMISSION,
    requestSchema: requestSchemas.accountPermissions.deactivateAccountPermissions,
  },
  {
    action: 'getAccountPermissions',
    message: messages.SUCCESS_GET_ACCOUNT_PERMISSIONS,
    method: 'GET',
    path: '/account/:accountId/permissions',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_ACCOUNT_PERMISSION,
    requestSchema: requestSchemas.accountPermissions.getAccountPermissions,
    scopes: [scopes.DEFAULT],
  },
];
